<template>
    <div class="container mt-5">
      <h2>Login</h2>
      <form @submit.prevent="login">
        <div class="form-group">
          <label for="email">Email</label>
          <input type="email" v-model="email" class="form-control" id="email" required>
        </div>
        <div class="form-group">
          <label for="password">Password</label>
          <input type="password" v-model="password" class="form-control" id="password" required>
        </div>
        <button type="submit" class="btn btn-primary mt-3">Login</button>
        <button type="button" @click="resetPassword" class="btn btn-secondary mt-3 ml-2">Reset Password</button>
      </form>
      <div v-if="error" class="mt-3 text-danger">{{ error }}</div>
      <div v-if="resetMessage" class="mt-3 text-success">{{ resetMessage }}</div>
    </div>
  </template>
  
  <script>
  import { ref } from 'vue';
  import { getAuth, signInWithEmailAndPassword, sendPasswordResetEmail } from 'firebase/auth';
  
  export default {
    name: 'LoginPage',
    setup() {
      const email = ref('');
      const password = ref('');
      const error = ref('');
      const resetMessage = ref('');

      const login = async () => {
        const auth = getAuth();
        try {
          await signInWithEmailAndPassword(auth, email.value, password.value);
          window.location.reload();
        } catch (err) {
          console.error('Error logging in:', err);
          error.value = 'Failed to log in. Please check your credentials and try again.';
        }
      };

      const resetPassword = async () => {
        const auth = getAuth();
        try {
          await sendPasswordResetEmail(auth, email.value);
          resetMessage.value = 'Password reset email sent. Please check your inbox.';
          error.value = ''; // Clear any existing error messages
        } catch (err) {
          console.error('Error sending password reset email:', err);
          error.value = 'Failed to send password reset email. Please check your email address and try again.';
          resetMessage.value = ''; // Clear any existing reset messages
        }
      };

      return {
        email,
        password,
        login,
        resetPassword,
        error,
        resetMessage,
      };
    },
  };
  </script>
  
  <style scoped>
  .container {
    max-width: 400px;
    margin: 0 auto;
  }
  
  .form-group {
    margin-bottom: 1.5rem;
  }
  
  .btn {
    width: 100%;
  }
  
  .text-danger {
    color: #dc3545;
  }
  
  .text-success {
    color: #28a745;
  }
  
  .ml-2 {
    margin-left: 0.5rem;
  }
  </style>
